module.exports = __webpack_public_path__ + "static/header-5cd90f65627daed11d5b13051a0cfa9f.png";